module.exports = __webpack_public_path__ + "static/logo-brand-a0bd81276c452cf1b627d822f3505fff.svg";